import React from "react";

const BonusIncentiveGraph = ({
  bonus = 7500,
  incentive = 4500,
  total = 12000,
}) => {
  const outerRadius = 90;
  const innerRadius = 72;

  const outerCircumference = Math.PI * outerRadius;
  const innerCircumference = Math.PI * innerRadius;

  const bonusStroke = (bonus / total) * outerCircumference;
  const incentiveStroke = (incentive / total) * innerCircumference;

  return (
    <div className="d-flex flex-column align-items-center">
      <style>
        {`
          .dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
          }
        `}
      </style>

      <svg width="450" height="350" viewBox="0 0 220 130">
        {/* Outer background */}
        <path
          d="M20 110 A90 90 0 0 1 200 110"
          fill="none"
          stroke="#EAF2F8"
          strokeWidth="14"
        />

        {/* Inner background */}
        <path
          d="M38 110 A72 72 0 0 1 182 110"
          fill="none"
          stroke="#F1F7FA"
          strokeWidth="12"
        />

        {/* Bonus (Outer arc) */}
        <path
          d="M20 110 A90 90 0 0 1 200 110"
          fill="none"
          stroke="#1976D2"
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray={`${bonusStroke} ${outerCircumference}`}
        />

        {/* Incentive (Inner arc) */}
        <path
          d="M38 110 A72 72 0 0 1 182 110"
          fill="none"
          stroke="#6EC6D2"
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={`${incentiveStroke} ${innerCircumference}`}
        />

        {/* Center Text */}
        <text x="110" y="70" textAnchor="middle" fontSize="14" fill="#666">
          Total
        </text>
        <text
          x="110"
          y="92"
          textAnchor="middle"
          fontSize="20"
          fontWeight="600"
        >
          ${total.toLocaleString()}
        </text>
      </svg>

      {/* Legends */}
      <div className="d-flex gap-4 mt-3">
        <div className="d-flex align-items-center gap-2">
          <span className="dot" style={{ background: "#1976D2" }}></span>
          <span>Bonus ${bonus.toLocaleString()}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <span className="dot" style={{ background: "#6EC6D2" }}></span>
          <span>Incentive ${incentive.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default BonusIncentiveGraph;
